const { plan } = require('../tool/plan.js');
const { cpps } = require('../tool/cppid.js');

let RE = {
    game:'wittledefender',  //游戏名称

    isShowModal: true,  //是否显示弹窗
    isPost: false,  //弹窗是否后置
    modalType: 1,   //弹窗类型          7种
    modalBtnType: 1,  //弹窗按钮类型     7种
    bannerType: 1,  //banner类型        2种
    bannerBtnType: 1,   //banner按钮      7种
    detailType: 1,  //详情页类型      2种
    language: 'TW',    //语言

    os: null,       //操作系统

    appType: '',       //app类型
    planid: '',  //版本号  根据版本号会获取上述配置

    cppid: null,  //识别cppid 跳转不同连接  -- iOS默认是从1到99，and是100及以上
    url: '',  //跳转地址
    iosUrl: 'https://apps.apple.com/ca/app/wittle-defender/id6502815032',  //默认地址
    AndUrl: 'https://play.google.com/store/apps/details?id=com.game.kingrush',  //默认地址

    FB: 'https://www.facebook.com/Wittle.Defender.HMT/posts/pfbid022c9mHnwNtckeospicncfVSnuU6weeMwWkQXsC65PXZJ7M45xbFzQGBQArVFqLFPQl',
    X: 'https://x.com/WittleD_JP/status/1910233511065448918',
    naver: 'https://game.naver.com/lounge/Wittle_Defender/board/detail/5872009',

    pid: null,  //渠道  fb/gg/tt/x
    imgsUrl: 'https://wittledefender.habby.com',    //图片地址

    track: 'wittledefender',       //打点名称
    sandbox: null,  //是否是沙盒环境

    c: '',
    adset: '',
    ad: '',
}

let modalObj = {
    'a' : 1,
    'b' : 2,
    'c' : 3,
    'd' : 4,
    'e' : 5,
    'f' : 6,
    'g' : 7,
    'h' : 8,
    'i' : 9,
    'j' : 10,
    'k' : 11,
    'l' : 12,
    'm' : 13,
    'n' : 14,
    'o' : 15,
    'p' : 16,
    'q' : 17,
    'r' : 18,
    's' : 19,
    't' : 20,
    'u' : 21,
    'v' : 22,       
}

let detailObj = {
    '11' : 1,
    '22' : 2,
}

if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(new URL(window.location.href).search);

    const ipPattern = /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])$/;
    RE.sandbox = (window.location.hostname.includes('test-') || window.location.hostname == 'localhost' || ipPattern.test(window.location.hostname)) ? true : false;  //是否是沙盒环境
    RE.imgsUrl = (window.location.hostname.includes('test-') || window.location.hostname == 'localhost' || ipPattern.test(window.location.hostname)) ? 'https://test-wittledefender.habby.com' : 'https://wittledefender.habby.com';  //是否是沙盒环境

    const paramsObject = {};
    urlParams.forEach((value, key) => {
        paramsObject[key] = value;
    });

    if(paramsObject.pid){
        RE.pid = paramsObject.pid || null;
    }

    RE.c = paramsObject.c || '';
    RE.adset = paramsObject.adset || '';
    RE.ad = paramsObject.ad || '';

    let array = plan.filter(item => item.planid == paramsObject.plan);

    if(array.length > 0){
        RE.isPost = array[0].isPost == '是' ? true : false;
        if(RE.isPost){
            RE.isShowModal = false;
        } else {
            RE.isShowModal = array[0].isShowModal == '有' ? true : false;
        }
        RE.modalType = modalObj[array[0].modalType] || 1;
        if(array[0].modalBtnType){
            RE.modalBtnType = modalObj[array[0].modalBtnType] || 1;
        }else{
            RE.modalBtnType = RE.modalType;
        }
        RE.bannerType = array[0].bannerType <= 8 ?  array[0].bannerType : 1;
        if(array[0].bannerBtnType){
            RE.bannerBtnType = modalObj[array[0].bannerBtnType] <= 8 ? modalObj[array[0].bannerBtnType] : 1;
        }else{
            RE.bannerBtnType = RE.bannerType;
        }
        RE.detailType = detailObj[array[0].detailType] <= 2 ? detailObj[array[0].detailType] : 1;
        RE.language = array[0].language || 'TW';
        RE.planid = array[0].planid;
    }

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // 检查是否是 Android 设备
    if (/android/i.test(userAgent) || /Win32|Win64|Windows|WinCE/.test(userAgent)) {
        RE.os = 0;
    }

    // 检查是否是 iOS 设备
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream || /Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
        RE.os = 1;
    }

    let cppObj = cpps.filter(item => item.cppid == paramsObject.cppid);
    if(cppObj.length > 0){
        RE.cppid = cppObj[0].cppid || 100;         //-- iOS默认是从1到99，and是100及以上
        let sys = cppObj[0].system;
        if (sys == 'iOS'){
            RE.url = RE.os == 1 ? cppObj[0].url : RE.iosUrl;
        }
        if (sys == 'AND'){
            RE.url = RE.os == 0 ? cppObj[0].url : RE.AndUrl;
        }
    }

    if(!RE.url){
        RE.url = RE.os == 1 ? RE.iosUrl : RE.AndUrl;
    }
}
// console.log(RE, 'RE');

module.exports = RE;



// WEBPACK FOOTER //
// ./src/assets/replace.js